import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Checkbox} from 'antd';
import { FormattedMessage} from 'react-intl';
import { fetchPrinters } from '../actions/printers';
import SearchTable from './SearchTable'
import LoadingControl from './Loading';
import { compareStrings } from '../utils/utils';
import '../App.css';

class PrintersSelectTable extends Component {

    constructor(props) {
        super(props);

        if (this.props.printer_id !== undefined)
        {
            // отмеченные принтеры в отчете переставляем в начало таблицы
            this.props.printers.sort((x, y) => { return x.id === this.props.printer_id ? -1 : y.id === this.props.printer_id ? 1 : 0; });
        }

        this.state = {
            showPrinters: this.props.printer_id === undefined ? false : true,
            selectedRowKeys: this.props.printer_id === undefined ? [] : [this.props.printer_id],
          };

        this.layout = {
            bordered : true,
            showSizeChanger : false, 
            pagination : {pageSize: 10, showSizeChanger: false},
            size: "small",
            rowKey : record => record.id,
        };

        this.columns = [
            {
              title: <FormattedMessage id="SuppliesHistoryTable.device"/>,
              dataIndex: 'prnName',
              
              sorter: {
                compare: (a, b) => compareStrings(a.prnName, b.prnName)
              },
              search: true,
            },
            {
              title: <FormattedMessage id="SuppliesChangesTable.description"/>,
              dataIndex: 'description',
              
              sorter: {
                compare: (a, b) => compareStrings(a.description, b.description)
              },
              search: true,
            },
            {
                title: <FormattedMessage id="DeviceMetersTable.ip"/>,
                dataIndex: 'ip',
                
                sorter: {
                  compare: (a, b) => compareStrings(a.ip, b.ip)
                },
                search: true,
                render: (_, record) =>
                     <div
                    style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '2px'
                    }}
                    >
                    <a href={'http://' + record.ip} target='_blank' rel="noopener noreferrer">{record.ip}</a> 
                    </div>
            } 
        ];   
      }
      
    componentDidMount() {  
        if (this.props.printers === undefined || this.props.printers.length === 0)
        {
            this.props.fetchData();
        }
    }

    onAllDevices(e)
    {
        this.setState({showPrinters: !e.target.checked});

        if (this.props.onSelectChange !== undefined && e.target.checked)
        {
            this.props.onSelectChange([undefined]);
        }
    }

    onSelectChange(selectedRowKeys) {
        if (this.props.onSelectChange !== undefined)
        {
            this.props.onSelectChange(selectedRowKeys);
        }
    }

    render() {
        if(this.props.hasError != null)
        {
          return (
            <div><h3>{this.props.hasError.message}</h3></div>
          );
        }
        else if (this.props.isLoading)
        {
          return (
            <div><LoadingControl size="small"/></div>
          );
        }
        else
        {
            return (
                <div>
                    <Checkbox checked={!this.state.showPrinters} onChange={(e) => this.onAllDevices(e)}><FormattedMessage id="AllDevices"/></Checkbox>
                    <br></br><br></br>
                    {this.state.showPrinters && 
                                        <SearchTable
                                            layout = {this.layout}
                                            type = "radio"
                                            onSelectChange = {(selectedRowKeys) => this.onSelectChange(selectedRowKeys)}
                                            initialSelection={this.state.selectedRowKeys}
                                            columns={this.columns} 
                                            dataSource={this.props.printers} />
                        }
                </div>
            );
        }
      }
}
const mapStateToProps = (state) => {
    return {
        printers: state.printers,
        hasError: state.printersHasError,
        isLoading: state.printersIsLoading,
    };
  };

const mapDispatchToProps = (dispatch) => {
return {
    fetchData: () => dispatch(fetchPrinters()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintersSelectTable);